import APP_ACTIONS from '../constants/app-actions';

const orderList = {
    addOrders: (ordersResponse, meta) => ({
        type: APP_ACTIONS.ADD_ORDERS,
        payload: {
            orders: ordersResponse,
            meta: {
                totalCount: meta.total_count,
                totalPages: meta.total_pages,
            },
        },
    }),

    addOrder: (order, meta) => ({
        type: APP_ACTIONS.ADD_ORDER,
        payload: {
            order,
            meta: {
                totalCount: meta.total_count,
                totalPages: meta.total_pages,
            },
        },
    }),
};

export default orderList;



/** WEBPACK FOOTER **
 ** ./src/actions/order-list.js
 **/